var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstTimeBusinessManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1752201682177,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1537,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M742.5 112.1c54.8 0 105.7 28.2 134.7 74.7l73.7 117.8c15.4 24.7 7.8 57.1-16.8 72.5-7.3 4.5-15.5 7.2-24.1 7.8v482c0 21.9-17.8 39.7-39.7 39.7H155.2c-21.9 0-39.7-17.8-39.7-39.7v-482c-29-2.1-50.8-27.2-48.7-56.2 0.6-8.6 3.3-16.8 7.9-24.1l73.7-117.8c29-46.5 80-74.7 134.7-74.7h459.4z m-98.6 265.2l-12.8 4.8c-71.8 28.9-151.7 30.5-224.6 4.6l-12-4.6c-63.3-25.5-132.7-31.6-199.5-17.4v462.4h635.6V364.8c-62.3-13.2-126.9-8.8-186.7 12.5z m-91.4 290.9c21.9 0 39.7 17.8 39.7 39.8 0 21.9-17.8 39.7-39.7 39.7H314.1c-21.9 0-39.7-17.8-39.7-39.8 0-21.9 17.8-39.7 39.7-39.7h238.4z m158.9 0c21.9 0 39.7 17.8 39.7 39.8 0 21.9-17.8 39.7-39.7 39.7h-39.7c-21.9 0-39.7-17.8-39.7-39.8 0-21.9 17.8-39.7 39.7-39.7h39.7z m31.1-476.7H283c-25 0-48.5 11.8-63.5 31.7l-3.9 5.6-36.3 58.1 6-1.3c75.1-14.6 152.9-8.7 225.3 17.7l13.5 5.2c53.2 21.4 112.4 22.9 166.6 4l10.7-4c75.7-30.5 158.7-38.4 238.8-22.8l5.9 1.3-36.3-58.1c-13.2-21.2-35.7-34.9-60.6-37.1l-6.7-0.3z",
    "p-id": 1538,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstTimeBusinessManagement);
export default __webpack_public_path__ + "static/media/firstTimeBusinessManagement.b6ce152a.svg";
export { ForwardRef as ReactComponent };